<style scoped="scoped" lang="scss"></style>

<template>
	<div style="display: inline;">
		<!-- table表格 -->
		<yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/production/woprocedure/page" getKey="rows" :columns="columns">
			<!-- 搜索框插槽 -->
			<template #conditions>
				<el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
					<el-form-item class="noborder" :label="$t('shengchangongdanhao')">
						<el-input disabled v-model="$attrs.processWork.no"></el-input>
					</el-form-item>
					<el-form-item class="noborder" :label="$t('jihuashuliang')">
						<el-input disabled v-model="$attrs.work.quantity"></el-input>
					</el-form-item>
					<el-form-item class="noborder" :label="$t('chanpinbianma/mingcheng')">
						<yi_cross_select disabled multiple :selectTitle="'code,name'" :component="'web_base_matter_list'" :ids.sync="$attrs.work.materialId">
						</yi_cross_select>
					</el-form-item>
					<yi_curd_expand_button></yi_curd_expand_button>
				</el-form>
			</template>
			<!-- 右侧按钮插槽 -->
			<template #buttonsR>
				<el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
			</template>
			<!-- 操作插槽 -->
			<template #caozuo="scope">
				<el-row :gutter="10">
					<el-col :span="0.1">
						<el-button type="text" @click="yt.showEditDialog('baogongjilu', scope.row, 'w2')">
							{{ $t('baogongjilu') }}</el-button>
					</el-col>
				</el-row>
			</template>
		</yi_curd_table>

		<!-- 新增/编辑弹框 -->
		<el-dialog v-dialog-drag :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">

			<!-- 报工记录-->
			<template v-if="yt.editObj.action == 'baogongjilu'">
				<div class="dialog-scroller">
					<report :chart="$attrs.processWork" :reportWork="yt.editObj" :work="$attrs.processWork"></report>
				</div>
			</template>
		</el-dialog>
	</div>
</template>
<script type="text/javascript">
import report from '@@/pages/web/order_management/production_plan_customized/work_order/report'
export default {
	name: 'web_order_management_production_plan_customized_work_order_process',
	components: {
		report
	},
	data() {
		return {
			columns: [{
				label: 'gongxugongdanhao',
				prop: 'no',
				width: 130
			}, {
				label: 'gongxubianma',
				prop: 'procedureCode',
				width: 130
			}, {
				label: 'gongxumiaoshu',
				prop: 'procedureDesc',
				width: 150,
			},
			{
				label: 'jihuashuliang',
				prop: 'planQuantity',

			},
			{
				label: 'baogongshuliang',
				prop: 'reportQuantity',
				width: 150,
			}, {
				label: 'yibaogongliangpinshu',
				prop: 'finishGoodQuantity',
				width: 150,
			}, {
				label: 'yibaogongbuliangpinshu',
				prop: 'finishBadQuantity',
				width: 150,
			}, {
				label: 'shengyushengchanshuliang',
				prop: 'leftProductionQuantity',
				width: 150,
			}, {
				label: 'caozuo',
				type: 'slot',
				width: 130,
				fixed: 'right'
			}
			]
		};
	},

	created() {
		setTimeout(() => {
			this.yt.conditions = {
				woId: this.$attrs.processWork.id,
				// orderBy: 'planStartTime,equipmentId asc',
			}
			this.yt.get(1)
		}, 300)
	},
	methods: {

	}
};
</script>
